import React, {Component} from 'react';
import {getExtension, iconFromExtension} from 'common/utils';
import {Icon, Segment, Form, Header} from 'semantic-ui-react';
import {TextAreaField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import REST from 'go/requests/rest';

export class FileCard extends Component {
  renderIcon(fileName) {
    let type = getExtension(fileName);
    let {name, color} = iconFromExtension(type);
    return <Icon name={name} color={color} />;
  }

  renderDescription(description) {
    return (
      <Form>
        <Form.Field>
          <TextAreaField
            rows={6}
            title="Description"
            label="Description"
            value={description}
          />
        </Form.Field>
      </Form>
    );
  }

  render() {
    const {file, supportDescription} = this.props;
    const {fileName, resourceId} = file;
    const extensionIcon = this.renderIcon(fileName);
    const downloadUrl = REST.attachment.getAttachmentDownloadUrl(resourceId);

    return (
      <div className="fileCard">
        <Segment raised>
          <div className="fileCardInner">
            {extensionIcon}
            <Header as="h4">{fileName}</Header>
            {supportDescription && this.renderDescription()}
            <a href={downloadUrl} className="downloadBtn">
              Download
            </a>
          </div>
        </Segment>
      </div>
    );
  }
}

export default FileCard;
